import React, { useState, useEffect } from "react";
import {
  Container,
  Paper,
  Box,
  TextField,
  Button,
  Typography,
  Snackbar,
  Alert,
  Autocomplete,
} from "@mui/material";
import axios from "axios";
import BaseURL from "../../api/AppURL";

export default function AddPermission({ onSaveSuccess }) {
  const [values, setValues] = useState({
    username: "",
    name: "",
    email: "",
    phone: "",
    address: "",
    password: "",
    role: null, // একমাত্র role id রাখতে হবে
  });

  const [roleOptions, setRoleOptions] = useState([]); // role objects: {id, name}
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const handleSnackbarClose = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbar((s) => ({ ...s, open: false }));
  };

  const handleChange = (field) => (e) => {
    setValues((v) => ({ ...v, [field]: e.target.value }));
    setErrors((err) => ({ ...err, [field]: null }));
  };

  const validate = () => {
    const err = {};
    if (!values.username.trim()) err.username = "Permission Name is required";
    if (!values.role) err.role = "Group Name is required";  // এটাই চেক করো
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const token = localStorage.getItem("auth_token");
        const res = await axios.get(`${BaseURL}/add/admin`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        if (res.data && res.data.roles) {
          setRoleOptions(res.data.roles); // পুরো role object রাখছি
        }
      } catch (err) {
        setSnackbar({
          open: true,
          severity: "error",
          message: "Failed to load roles from server",
        });
      }
    };
    fetchRoles();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      setSnackbar({
        open: true,
        severity: "error",
        message: "Fix validation errors",
      });
      return;
    }
    setLoading(true);
    try {
      const token = localStorage.getItem("auth_token");
      const postData = {
        name: values.username,
        group_name: values.role,  // role id পাঠানো হবে
      };
      const res = await axios.post(
        `${BaseURL}/store/permission`,
        postData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      setSnackbar({ open: true, severity: "success", message: res.data.message || "Admin created" });
      if (typeof onSaveSuccess === "function") onSaveSuccess(res.data.message);

      setValues({
        username: "",
        group_name: null,
      });
    } catch (err) {
      const msg = err?.response?.data?.message || "Failed to create admin";
      setSnackbar({ open: true, severity: "error", message: msg });
    } finally {
      setLoading(false);
    }
  };


  // roleOptions এর পরিবর্তে groupOptions ব্যবহার করব
  const groupOptions = [
    { id: "account", name: "Accounts" },
    { id: "dashboard", name: "Dashboard" },
    { id: "sale", name: "Sales" },
    { id: "hrm", name: "HRM" },
    { id: "manufacture", name: "Manufacture" },
    { id: "product", name: "Product" },
    { id: "authorise", name: "Authorise" },
    { id: "brand", name: "Brand" },
    { id: "category", name: "Category" },
    { id: "subcategory", name: "Subcategory" },
    { id: "slider", name: "Slider" },
    { id: "ads", name: "Ads" },
    { id: "coupon", name: "Coupon" },
    { id: "area", name: "Area" },
    { id: "vendor", name: "Vendor" },
    { id: "order", name: "Order" },
    { id: "return", name: "Return" },
    { id: "report", name: "Report" },
    { id: "user", name: "User Management" },
    { id: "review", name: "Review" },
    { id: "setting", name: "Setting" },
    { id: "blog", name: "Blog" },
    { id: "role", name: "Role" },
    { id: "admin", name: "Admin" },
    { id: "stock", name: "Stock" },
    { id: "website", name: "Website" },
    { id: "erp", name: "ERP" },
    { id: "areamanager", name: "Area Manager" },
    { id: "producttest", name: "Product Test" },
    { id: "permission", name: "Permission" },
    { id: "adminPermission", name: "AdminPermission" },
  ];

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h6" gutterBottom>
          Add Permission
        </Typography>

        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          sx={{ display: "flex", flexDirection: "column", gap: 2 }}
        >
          <TextField
            label="Permission Name"
            value={values.username}
            onChange={handleChange("username")}
            required
            error={!!errors.username}
            helperText={errors.username}
          />





          {/* <Autocomplete
            options={roleOptions}
            getOptionLabel={(option) => option.name}
            value={roleOptions.find((r) => r.id === values.role) || null}
            onChange={(_, newValue) => setValues((v) => ({ ...v, role: newValue ? newValue.id : null }))}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Group Name"
                required
                error={!!errors.role}
                helperText={errors.role}
              />
            )}
          /> */}




          <Autocomplete
            options={groupOptions}
            getOptionLabel={(option) => option.name}
            value={groupOptions.find((r) => r.id === values.role) || null}
            onChange={(_, newValue) =>
              setValues((v) => ({ ...v, role: newValue ? newValue.id : null }))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Group Name"
                required
                error={!!errors.role}
                helperText={errors.role}
              />
            )}
          />


          <Button type="submit" variant="contained" disabled={loading}>
            {loading ? "Saving..." : "Save Changes"}
          </Button>
        </Box>
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
}
